// Presentational, static marketing content (not product data).

export const heroSlides = [
  {
    id: 1,
    title: 'WorldMarket — le monde à petits prix',
    subtitle: "Des milliers de produits importés, livrés chez vous",
    cta: 'Découvrir',
    link: '/categorie/tous',
    image: 'https://images.unsplash.com/photo-1483985988355-763728e1935b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    bg: 'from-indigo-50 to-sky-50',
  },
  {
    id: 2,
    title: 'High-tech & gadgets',
    subtitle: 'Jusqu\'à -50% sur l\'électronique et les accessoires',
    cta: "J'en profite",
    link: '/categorie/electronique',
    image: 'https://images.unsplash.com/photo-1498049794561-7780e7231661?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    bg: 'from-slate-50 to-zinc-50',
  },
  {
    id: 3,
    title: 'Maison & déco tendance',
    subtitle: 'Transformez votre intérieur sans vous ruiner',
    cta: 'Voir la sélection',
    link: '/categorie/maison',
    image: 'https://images.unsplash.com/photo-1616046229478-9901c5536a45?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    bg: 'from-amber-50 to-orange-50',
  },
];

export const universes = [
  { name: 'Maison', icon: 'Home', color: 'bg-amber-50', textColor: 'text-amber-600', categoryId: 'maison' },
  { name: 'Mode', icon: 'Shirt', color: 'bg-rose-50', textColor: 'text-rose-600', categoryId: 'mode' },
  { name: 'Électronique', icon: 'Smartphone', color: 'bg-slate-100', textColor: 'text-slate-700', categoryId: 'electronique' },
  { name: 'Beauté', icon: 'Sparkles', color: 'bg-pink-50', textColor: 'text-pink-600', categoryId: 'beaute' },
  { name: 'Jardin', icon: 'Flower2', color: 'bg-green-50', textColor: 'text-green-600', categoryId: 'jardin' },
  { name: 'Sport', icon: 'Dumbbell', color: 'bg-blue-50', textColor: 'text-blue-600', categoryId: 'sport' },
  { name: 'Bébé', icon: 'Baby', color: 'bg-sky-50', textColor: 'text-sky-600', categoryId: 'bebe' },
  { name: 'Auto', icon: 'Car', color: 'bg-neutral-100', textColor: 'text-neutral-700', categoryId: 'auto' },
];

export const reviews = [
  { id: 1, name: 'Marie D.', rating: 5, comment: 'Excellent produit, livraison conforme. Je recommande !', date: '15 juin 2026', verified: true },
  { id: 2, name: 'Pierre L.', rating: 5, comment: 'Très satisfait de mon achat, qualité au rendez-vous.', date: '10 juin 2026', verified: true },
  { id: 3, name: 'Sophie M.', rating: 4, comment: 'Bon rapport qualité/prix, conforme à la description.', date: '5 juin 2026', verified: true },
  { id: 4, name: 'Jean P.', rating: 5, comment: 'Parfait, livraison un peu longue mais produit nickel.', date: '28 mai 2026', verified: true },
];
